import React, { useEffect, useState } from "react";
import api from "../api";
import { useI18n } from "../i18n";

export default function Inquiries() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try { const { data } = await api.get("/inquiries"); setItems(data); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function setStatus(id, status) {
    await api.patch(`/inquiries/${id}`, { status });
    load();
  }

  return (
    <div className="container-cd py-12" data-testid="inquiries-page">
      <div className="overline">INBOX · RFQ</div>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[0.9]">{t("inq.title")}</h1>

      {loading ? (
        <div className="mt-10 overline">{t("common.loading")}</div>
      ) : items.length === 0 ? (
        <div className="mt-10 cd-card p-12 text-center font-mono text-sm" data-testid="inq-empty">{t("inq.empty")}</div>
      ) : (
        <div className="mt-10 space-y-4">
          {items.map((i) => (
            <article
              key={i.inquiry_id}
              className="cd-card p-6"
              style={{ borderColor: i.status === "new" ? "var(--orange)" : "var(--line)" }}
              data-testid={`inquiry-${i.inquiry_id}`}
            >
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <div className="overline">{i.status.toUpperCase()} · {new Date(i.created_at).toLocaleString()}</div>
                  <h3 className="font-heading text-xl font-semibold mt-1">{i.subject}</h3>
                  <div className="font-mono text-xs mt-1" style={{ color: "var(--ink-2)" }}>
                    {t("inq.from")} {i.buyer_name} · {i.buyer_company || "—"} · {i.buyer_email}
                  </div>
                </div>
                <div className="flex gap-2">
                  {i.status === "new" && (
                    <button className="btn btn-ghost btn-sm" onClick={() => setStatus(i.inquiry_id, "read")} data-testid={`inq-read-${i.inquiry_id}`}>
                      {t("inq.mark_read")}
                    </button>
                  )}
                  {i.status !== "archived" && (
                    <button className="btn btn-ghost btn-sm" onClick={() => setStatus(i.inquiry_id, "archived")} data-testid={`inq-archive-${i.inquiry_id}`}>
                      {t("inq.archive")}
                    </button>
                  )}
                  <a href={`mailto:${i.buyer_email}?subject=Re: ${encodeURIComponent(i.subject)}`} className="btn btn-primary btn-sm">
                    Reply →
                  </a>
                </div>
              </div>
              <p className="mt-4 text-sm whitespace-pre-wrap">{i.message}</p>
              {(i.quantity || i.timeline) && (
                <div className="mt-4 flex gap-4 font-mono text-xs" style={{ color: "var(--ink-2)" }}>
                  {i.quantity && <span>QTY · {i.quantity}</span>}
                  {i.timeline && <span>TIMELINE · {i.timeline}</span>}
                  {i.buyer_phone && <span>PHONE · {i.buyer_phone}</span>}
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
